import { Experiences } from "@/getServerSideProps/monetate/getExperiences/experiencesSchema";

export const encodeExperiencesObject = (
  experiencesRawObject: Experiences = [],
) => {
  try {
    if (typeof window === "undefined") {
      return Buffer.from(JSON.stringify(experiencesRawObject), "utf8").toString(
        "base64",
      );
    } else {
      return window.btoa(JSON.stringify(experiencesRawObject));
    }
  } catch (e) {
    return "W10="; // the object is validated in gerServerSideProps so this should only happen in tests
  }
};
